/**
 * useBackHandler — modal-safe Android hardware Back button.
 *
 * Web build: no-op. On native, while `active` is true this component's
 * `onBack` runs before router history. If `onBack` returns anything
 * (including `undefined`, which is treated as "consumed"), the event
 * won't propagate. Returning `false` explicitly lets the default
 * handler run — useful for "back once = dismiss, back again = navigate".
 *
 * Usage:
 *   useBackHandler(isModalOpen, () => setModalOpen(false));
 */

import { useEffect } from 'react';
import { pushBackHandler } from './native';

export const useBackHandler = (active, onBack) => {
  useEffect(() => {
    if (!active || typeof onBack !== 'function') return undefined;
    const unsub = pushBackHandler(() => {
      const result = onBack();
      // Anything other than an explicit `false` counts as consumed.
      return result !== false;
    });
    return unsub;
  }, [active, onBack]);
};
